import React from 'react'

import Section from '../../../../../../components/Section'
import { Purchase } from '../../../types'

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseGuid: string | undefined
    purchasesLoading: boolean
    purchasesError: string | null
    purchase: Purchase
}

const PurchaseContactInfo: React.FC<Props> = (props) => {
    return (
        <Section title="Контактная информация">
            <fieldset disabled={props.purchaseAction}>
                <div className="flex flex-col w-full gap-3">
                    <div className="flex flex-col w-[420px]">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Контактное лицо{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <input
                            type="text"
                            className={`form-input user-input-placeholder w-full`}
                            value={
                                props.purchase?.contact
                                    ? (props.purchase.contact.last_name ?? '') +
                                      ' ' +
                                      (props.purchase.contact.first_name ??
                                          '') +
                                      ' ' +
                                      (props.purchase.contact.middle_name ?? '')
                                    : '-'
                            }
                            style={{
                                colorScheme:
                                    props.theme == 'dark' ? 'dark' : 'light',
                            }}
                        />
                    </div>
                    <div className="flex flex-row w-full gap-x-5 items-start justify-start ">
                        <div className="flex flex-col w-[200px] ">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Электронная почта
                            </label>
                            <input
                                type="text"
                                className={`form-input user-input-placeholder w-full`}
                                value={
                                    props.purchase?.contact?.email
                                        ? props.purchase.contact.email
                                        : ''
                                }
                                style={{
                                    colorScheme:
                                        props.theme == 'dark'
                                            ? 'dark'
                                            : 'light',
                                }}
                                readOnly
                            />
                        </div>
                        <div className="flex flex-col w-[200px]">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Контактный телефон
                            </label>
                            <input
                                type="text"
                                className={`form-input user-input-placeholder w-full`}
                                value={
                                    props.purchase?.contact?.phone
                                        ? props.purchase.contact.phone
                                        : ''
                                }
                                style={{
                                    colorScheme:
                                        props.theme == 'dark'
                                            ? 'dark'
                                            : 'light',
                                }}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Дополнительная контактная информация{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <textarea
                            className={`form-textarea w-full`}
                            maxLength={2000}
                            rows={3}
                            value={
                                props.purchase?.modification_description || ''
                            }
                        />
                    </div>
                </div>
            </fieldset>
        </Section>
    )
}

export default PurchaseContactInfo
